module.exports = __webpack_public_path__ + "img/main.md.a65204b1.jpg";